import { slrDividerPadding } from "../../ribbonStylingConstantsBase";

export const chevronWidth = 20;
export const tabContentContainerPadding = 8;

export const getVerticalDividerWidthSLR = () => {
  return Math.ceil(2 * slrDividerPadding + 1);
};

export const ribbonModeToggleId = "RibbonModeToggle";
